module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('p', {
    staticClass: "c12"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('strong', {
    staticClass: "calibre1"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "c13"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0005#page_vii"
    }
  }, [_vm._v("General editors' preface")])]), _vm._v(" "), _c('p', {
    staticClass: "c13"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0006#page_ix"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "c13"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0007#page_xi"
    }
  }, [_vm._v("Chronology")])]), _vm._v(" "), _c('p', {
    staticClass: "c13"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#page_xvi"
    }
  }, [_vm._v("Cue-titles")])]), _vm._v(" "), _c('p', {
    staticClass: "c13"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#page_xix"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#id_307"
    }
  }, [_vm._v("Sketches of Etruscan Places")])])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#page_liv"
    }
  }, [_vm._v("Italian Essays, 1919–27")])]), _vm._v(" "), _c('p', {
    staticClass: "c13"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0011#page_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SKETCHES OF ETRUSCAN PLACES")])])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#page_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I.       Cerveteri")])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0016#page_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II.     Tarquinia")])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0018#page_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III.    The Painted Tombs of Tarquinia 1")])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0022#page_113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV.     The Painted Tombs of Tarquinia 2")])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0024#page_135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V.      Vulci")])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0026#page_155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI.     Volterra")])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0028#page_173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII.   The Florence Museum")])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0020#page_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "c13"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0030#page_181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ITALIAN ESSAYS, 1919–27")])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0032#page_183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David")])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0034#page_191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Looking Down on the City")])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0037#page_197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Europe Versus America")])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0039#page_201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fireworks")])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0042#page_209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nightingale")])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0045#page_217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Man is a Hunter")])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0047#page_223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flowery Tuscany")])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0050#page_245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Germans and English")])]), _vm._v(" "), _c('p', {
    staticClass: "c13"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0052#page_253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendixes "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Sketches of Etruscan Places")])])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0052#id_308",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I 'The Painted Tombs of Tarquinia', First version")])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0055#page_267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II Historical outline")])]), _vm._v(" "), _c('p', {
    staticClass: "c14"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0057#page_273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III Photographs")])]), _vm._v(" "), _c('p', {
    staticClass: "c13"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0059#page_279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix IV Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "c13"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0061#page_285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix V 'Fireworks' [Fireworks in Florence]")])]), _vm._v(" "), _c('p', {
    staticClass: "c13"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0064#page_293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Explanatory notes")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-541d3dd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0004.vue
// module id = 72
// module chunks = 0